/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum InternalApiScenarioType {
    ONLINE = 'ONLINE',
    OFFLINE = 'OFFLINE',
    PERIODIC = 'PERIODIC',
    PERIODIC_ENTITY = 'PERIODIC_ENTITY'
}


export function instanceOfInternalApiScenarioType(value: any): boolean {
    for (const key in InternalApiScenarioType) {
        if (Object.prototype.hasOwnProperty.call(InternalApiScenarioType, key)) {
            if (InternalApiScenarioType[key as keyof typeof InternalApiScenarioType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function InternalApiScenarioTypeFromJSON(json: any): InternalApiScenarioType {
    return InternalApiScenarioTypeFromJSONTyped(json, false);
}

export function InternalApiScenarioTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiScenarioType {
    return json as InternalApiScenarioType;
}

export function InternalApiScenarioTypeToJSON(value?: InternalApiScenarioType | null): any {
    return value as any;
}

export function InternalApiScenarioTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): InternalApiScenarioType {
    return value as InternalApiScenarioType;
}

